import React from 'react';

import { Typography } from 'app/components/domain/typography';
import { BaseImageProps, Image } from 'app/components/common/image';
import { BaseSelectButton } from 'app/components/domain/select-button/base-select-button';

import styles from './address-select-button.module.scss';

interface Props {
    title: React.ReactNode;
    icon: BaseImageProps;
    text: React.ReactNode;
    onClick: () => void;
}

const AddressSelectButton: React.FC<Props> = (props) => {
    const { title, icon, text, onClick } = props;

    return (
        <BaseSelectButton className={styles.addressSelectButton} onClick={onClick}>
            <Image className={styles.image} {...icon} />
            <Typography className={styles.title} variant="subtitle3" component="p">
                {title}
            </Typography>
            <Typography className={styles.text} variant="body1" component="div">
                {text}
            </Typography>
        </BaseSelectButton>
    );
};

export { AddressSelectButton };
